import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { HistoryItem } from '../models/history-item';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Contact } from '../models/contact';
import { extractErrorMessage } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  baseUrl: string = environment.api_url;
  constructor(private readonly http: HttpClient) { }

  getEntityHistory(entityType: string, entityId: number): Observable<HistoryItem[]> {
    const params = new HttpParams().set('view', 'details');
    return this.http.get<HistoryItem[]>(`${this.baseUrl}/history/${entityType}/${entityId}`, { params }).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  getHistoryReport(): Observable<HttpResponse<ArrayBuffer>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const body = {}
    const params = {}
    return this.http.post(`${this.baseUrl}/history`, body, {
      params,
      headers,
      responseType: 'arraybuffer' as 'arraybuffer',
      observe: 'response'
    });
  }
}
